import type {
  ObjectRef,
  WorkbenchIntent,
  WorkbenchMode,
  WorkbenchVariant,
} from './workbench-focus';

export type WorkbenchSurfaceKind =
  | 'list'
  | 'detail'
  | 'board'
  | 'document_editor'
  | 'site_studio'
  | 'permission_matrix'
  | 'flow'
  | 'flow_board'
  | 'task'
  | 'task_execution'
  | 'relationship'
  | 'external_relationship'
  | 'settings'
  | 'exception_investigation'
  | 'voucher_entry'
  | 'collection_list'
  | 'collection_detail'
  | 'document_list'
  | 'document_detail'
  | 'order_list'
  | 'order_detail'
  | 'operation_executor'
  | 'stream_execute'
  | 'utility_page'
  | 'admin_list'
  | 'approval_detail';

export interface BusinessWorkspaceState {
  plane: 'business';
  domain?: string;
  subdomain?: string;
  surface: WorkbenchSurfaceKind;
  root?: ObjectRef;
  selection: ObjectRef[];
  intent: WorkbenchIntent;
  mode: WorkbenchMode;
  variant?: WorkbenchVariant;
  threadId?: string;
  exceptionId?: string;
  pane?: string;
  density?: string;
}

export interface SurfaceMemorySnapshot {
  routeFamily: string;
  filters?: Record<string, unknown>;
  sort?: { field: string; order: 'asc' | 'desc' };
  scrollAnchor?: string;
  selectedRowIds?: string[];
  /** Full selection refs (label/status) for list restore after detail navigation */
  selectedRowRefs?: ObjectRef[];
  page?: number;
  navigatorOpenKeys?: string[];
  capturedAt: string;
}

export interface SurfaceMemoryStore {
  read(routeFamily: string): SurfaceMemorySnapshot | undefined;
  write(routeFamily: string, snapshot: SurfaceMemorySnapshot): void;
}

export class InMemorySurfaceMemoryStore implements SurfaceMemoryStore {
  private readonly store = new Map<string, SurfaceMemorySnapshot>();

  read(routeFamily: string): SurfaceMemorySnapshot | undefined {
    return this.store.get(routeFamily);
  }

  write(routeFamily: string, snapshot: SurfaceMemorySnapshot): void {
    this.store.set(routeFamily, snapshot);
  }
}

export function createInMemorySurfaceMemoryStore(): SurfaceMemoryStore {
  return new InMemorySurfaceMemoryStore();
}
